export type UserCompany = {
    company_ref_id: number;
    id: string;
};

export type SelectableCompany = {
    company: string;
    data:{
        enabled: boolean;
        companyRefId: number;
        userCompanyMapId: string;
        live_company_flag: boolean;
        live_company_asia_flag: boolean;
        isInFocusList: boolean;
        isInPortfolio: boolean;
    }
    gim_subteam: string;
}

export type Company = {
    bbg_ticker: string;
    company: string;
    company_id: number;
    company_model_excel_name: string;
    company_ref_id: number;
    current_company_ref_flag: string;
    gim_subteam: string;
    gim_team: string;
    live_company_flag: number;
    live_company_asia_flag: number;
    ref_end_date: Date;
    ref_start_date: Date
    portfolio_flag: number;
};

export type LocalQuery = {
    company: string;
    gim_subteam: string;
    enabled: boolean;
}

export enum COMPANY_LIST_ENUM {
    FOCUS_LIST = "FOCUS_LIST", PORTFOLIO = "PORTFOLIO"
}

export enum FUND_ENUM {
    GLOBAL = "GLOBAL", ASIA = "ASIA"
}
